<template>
  <div class="monitoring-home">
    <v-row>
      <v-col>
        <div class="center-x-y title-home">
          <span class="welcome">
            Bem vindo ao Cancontrol
          </span>
          <img
            class="radar"
            :src="require('../../../styles/assets/radar.png')"
            height="60px"
            width="60px"
          />
        </div>
      </v-col>
    </v-row>
    <v-row>
      <v-col>
        <mapbox
          :zoom="8"
          :position="[-50.440266, -27.683528]"
          height="500px"
          width="100%"
          :json="scJson"
          :points="createPoints"
        />
      </v-col>
    </v-row>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import json from "../../../styles/assets/geoJson/sc.json";

export default {
  name: "monitoring-home",
  data: () => ({
    scJson: json
  }),
  computed: {
    ...mapGetters({
      getAnalyze: "monitoring/getAnalyze",
      getHistory: "monitoring/getHistory"
    }),
    createPoints() {
      let points = [];
      let monitorings = [...this.getAnalyze, ...this.getHistory];
      monitorings.map(monitoring => {
        points.push({
          type: "Feature",
          geometry: {
            type: "Point",
            coordinates: [monitoring.lon, monitoring.lat]
          }
        });
      });
      return points;
    }
  },
  components: {
    mapbox: () => import("../components/map")
  }
};
</script>
<style lang="scss" scoped>
.welcome {
  font-size: 40px;
  font-weight: 600;
  color: #717171;
}
.radar {
  margin-left: 1rem;
}
.title-home {
  margin-bottom: 3rem;
}
</style>
